'use client';

import dynamic from 'next/dynamic';
import Container from "@/components/ContentElements/Grid/Container";
import Column from "@/components/ContentElements/Grid/Column";
import {MapMarkerType} from "@/components/ContentElements/Map/DynamicMap";

const DynamicMap = dynamic(() => import('./DynamicMap'), {
    ssr: false,
});

interface Props {
    mapMarkers: MapMarkerType[]
}

export default function Map({mapMarkers}:Props) {

    return (
        <Container>
            <Column width="1">
                <DynamicMap mapMarkers={mapMarkers} />
            </Column>
        </Container>
    )
}
